/**
 * TICK-146 — what a ฿0 ticket means, said where the organizer sets the price.
 *
 * A ฿0 order has no transfer to prove, so the buyer attaches no slip and the order waits in
 * "ตรวจสอบสลิป" until a person approves it — the owner chose that over auto-issuing free tickets.
 * An organizer who types 0 without knowing this would find a queue they never expected, or
 * buyers who never got a ticket.
 */
export const FREE_TICKET_NOTICE =
  'ราคา ฿0 = บัตรฟรี — ผู้ซื้อไม่ต้องโอนเงินหรือแนบสลิป แต่ทุกออเดอร์จะรออยู่ใน "ตรวจสอบสลิป" ' +
  'และต้องอนุมัติเองทีละรายการ ผู้ซื้อได้บัตรหลังอนุมัติเท่านั้น';

/** A door-sale (offline) type never goes through online checkout, so its price is not a free ticket online. */
export function isFreeOnlineTicket(t: { priceRegular: number; offline?: boolean }): boolean {
  return t.priceRegular === 0 && !t.offline;
}

/** Asks before saving types that would become free; `true` when there are none or the organizer agrees. */
export function confirmFreeTickets(names: string[]): boolean {
  if (!names.length) return true;
  return window.confirm(
    `${names.join(', ')} — ราคา ฿0 (บัตรฟรี)\n\n` +
      'ทุกออเดอร์ของบัตรนี้จะไม่มีสลิป และต้องเข้าไปอนุมัติเองที่ "ตรวจสอบสลิป" ทีละรายการ — ' +
      'ระบบไม่อนุมัติให้อัตโนมัติ\n\nยืนยันราคา ฿0 ?',
  );
}
